import React from 'react';
import { Icon } from '@iconify/react';

const StockItemsDataTable = ({
  items,
  onEdit,
  onDelete,
  sortField,
  sortOrder,
  onSort,
}) => {
  const getWarehouseList = (quantities = []) => {
    const names = quantities
      .map((quantity) => quantity?.warehouse?.name)
      .filter(Boolean);
    return Array.from(new Set(names)).join(', ');
  };

  const getLocationCodeList = (quantities = []) => {
    const codes = quantities
      .map((quantity) => quantity?.locationCode)
      .filter(Boolean);
    return Array.from(new Set(codes)).join(', ');
  };

  const getSortIcon = (field) => {
    if (sortField !== field || !sortOrder) {
      return 'mdi:sort';
    }
    return sortOrder === 'asc' ? 'mdi:sort-ascending' : 'mdi:sort-descending';
  };

  const getPartNumbers = (parts = []) => {
    if (!Array.isArray(parts)) return '';
    return parts
      .map((part) => part?.partNumber)
      .filter(Boolean)
      .join(', ');
  };

  const sumQuantities = (quantities = []) =>
    quantities.reduce((total, quantity) => total + Number(quantity?.quantity ?? 0), 0);

  const sumQuantitiesByStatus = (quantities = [], statusId) =>
    quantities.reduce((total, quantity) => {
      if (Number(quantity?.stockItemStatusId) === statusId) {
        return total + Number(quantity?.quantity ?? 0);
      }
      return total;
    }, 0);

  const renderSortableHeader = (label, field) => {
    const ariaSort = sortField === field
      ? sortOrder === 'asc'
        ? 'ascending'
        : sortOrder === 'desc'
          ? 'descending'
          : 'none'
      : 'none';

    return (
      <th
        onClick={() => onSort?.(field)}
        style={{ cursor: 'pointer' }}
        scope="col"
        aria-sort={ariaSort}
      >
        <span className="d-inline-flex align-items-center gap-1">
          {label}
          <Icon className="text-xl" icon={getSortIcon(field)} />
        </span>
      </th>
    );
  };

  return (
    <table className="table bordered-table mb-3" style={{ width: '100%', borderRadius: '0' }}>
      <thead>
        <tr>
          <th style={{ borderRadius: '0' }}></th>
          {renderSortableHeader('Material Number', 'materialNumber')}
          {renderSortableHeader('Description', 'description')}
          {renderSortableHeader('Part Number', 'partNumber')}
          {renderSortableHeader('Warehouse', 'location')}
          <th>Location Code</th>
          <th className="text-center">Stock On Hand</th>
          <th className="text-center">Available</th>
          <th className="text-center">Reserved</th>
          <th className="text-center">On Back Order</th>
          <th className="text-center">Unit Cost</th>
          <th className="text-center">Unit</th>
          <th style={{ borderRadius: '0' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.id}>
            {(() => {
              const quantities = Array.isArray(item?.stockItemsQuantities)
                ? item.stockItemsQuantities
                : [];
              const stockOnHand = sumQuantities(quantities);
              const available = sumQuantitiesByStatus(quantities, 1);
              const reserved = sumQuantitiesByStatus(quantities, 15);
              const backOrder = sumQuantitiesByStatus(quantities, 5);
              return (
                <>
            <td>
              <img
                src={
                  item.stockImage && item.stockImage !== ''
                    ? `${process.env.REACT_APP_SPACES_BASE}/${item.stockImage}`
                    : `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`
                }
                alt="part"
                style={{ width: '45px', height: '45px', borderRadius: '50%', border: '1px solid #ddd' }}
              />
            </td>
            <td>{item.materialNumber}</td>
            <td>{item.description}</td>
            <td>{getPartNumbers(item.parts) || ''}</td>
            <td>{getWarehouseList(item?.stockItemsQuantities)}</td>
            <td>{getLocationCodeList(item?.stockItemsQuantities)}</td>
            <td className="text-center">{stockOnHand}</td>
            <td className="text-center">{available}</td>
            <td className="text-center">{reserved}</td>
            <td className="text-center">{backOrder}</td>
            <td className="text-center">{item.unitCost}</td>
            <td className="text-center">{item.measurementUnit?.unitCode}</td>
            <td>
              <div className="d-flex gap-2">
                <button
                  className="w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  onClick={() => onEdit(item)}
                >
                  <Icon icon="ic:baseline-edit" className="icon text-xl line-height-1" />
                </button>
                <button
                  className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  onClick={() => onDelete(item.id)}
                >
                  <Icon icon="ic:baseline-delete-outline" className="icon text-xl line-height-1" />
                </button>
              </div>
            </td>
                </>
              );
            })()}
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan={13} className="text-center py-2">
              No stock items found
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default StockItemsDataTable;
